export const GET_PARTS = 'GET_PARTS'
export const GET_PARTS_SUCCESS = 'GET_PARTS_SUCCESS'
export const UPDATE_PARTS_PAGINATION = 'UPDATE_PARTS_PAGINATION'
export const CREATE_PART = 'CREATE_PART'
export const CREATE_PART_SUCCESS = 'CREATE_PART_SUCCESS'
export const UPDATE_PART = 'UPDATE_PART'
export const UPDATE_PART_SUCCESS = 'UPDATE_PART_SUCCESS'
export const GET_PART = 'GET_PART'
export const GET_PART_SUCCESS = 'GET_PART_SUCCESS'
export const DELETE_PART = 'DELETE_PART'
export const DELETE_PART_SUCCESS = 'DELETE_PART_SUCCESS'